// extracted by mini-css-extract-plugin
export default {"wrapper":"giftCardFilter_wrapper__08zJ7","filterTypeSelection":"giftCardFilter_filterTypeSelection__XmK7G","filterMainLabel":"giftCardFilter_filterMainLabel__gMAO2"};